import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer/dist/react-pdf.es';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderTopWidth: 1,
        borderTopColor: '#db2129',
        borderTopStyle: 'solid',
        fontFamily: 'Crimson',
        fontSize: 8,
        position: 'absolute',
        bottom: 15,
        left:'20mm',
        right:'10mm',
    },
    columnOne: {
        flexDirection: 'column',
        flexGrow: 3,
    },
    columnTwo: {
        flexDirection: 'column',
        flexGrow: 4,
        alignItems:'flex-start',
        justifyContent:'flex-end',
        paddingLeft:10,
    },
    columnLast: {
        flexDirection: 'column',
        flexGrow: 1.5,
    },
    label:{
        fontFamily: 'Crimson Bold',
    },
    pageNumber: {
        fontSize: 10,
        position: 'absolute',
        bottom: '22mm',
        right: '20mm',
    },
});

export default () => (
    <React.Fragment>

        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => {
            if(pageNumber && totalPages && totalPages > 1) {
                return `Seite ${pageNumber}/${totalPages}`
            }
        }} fixed />
        <View style={styles.container} fixed>
            <View style={styles.columnOne}>
                <Text style={styles.label}>Geschäftsführer:</Text>
                <View style={{flexDirection:'row'}}>
                    <View style={{flexDirection:'column',flexGrow: 1}}>
                        <Text>Bauing.MSc</Text>
                    </View>
                    <View style={{flexDirection:'column',flexGrow: 1}}>
                        <Text>Thomas Weber</Text>
                    </View>
                </View>
            </View>
            <View style={styles.columnTwo}>
                <Text style={styles.label}>Bankverbindungen</Text>
                <View style={{flexDirection:'row'}}>
                    <View style={{flexDirection:'column',flexGrow:2}}>
                        <Text>Kreissparkasse Stendal</Text>
                        <Text> </Text>
                        <Text>Berliner Volksbank</Text>
                        <Text> </Text>
                    </View>
                    <View style={{flexDirection:'column',paddingLeft:10}}>
                        <Text>IBAN: DE40 8105 0555 3010 0110 15</Text>
                        <Text>BIC:  NOLADE21SDL</Text>
                        <Text>IBAN: DE11 1009 0000 2398 2580 05</Text>
                        <Text>BIC:  BEVODEBB</Text>
                    </View>
                </View>
            </View>
            <View style={styles.columnLast}>
                <Text style={styles.label}>Gerichtsstand:</Text>
                <Text>Stendal</Text>
            </View>
            <View style={styles.columnLast}>
                <Text style={styles.label}>Handelsregister:</Text>
                <Text>HRB 26096</Text>
                <Text style={styles.label}>UST-Ident-Nr.:</Text>
                <Text>139 531 001</Text>
            </View>
        </View>
    </React.Fragment>

);
